import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useHttpClient } from "../../shared/hooks/http-hook";

export default function OrgSettingsModal({
  show,
  onHide,
  loadedOrgData,  
  onOrgUpdated    // callback to reload parent data if needed
}) {
  const { isLoading, error, sendRequest } = useHttpClient();

  const [orgName, setOrgName] = useState(loadedOrgData?.name || "");
  const [tier, setTier] = useState(loadedOrgData?.tier || "");
  const [remainingCredits, setRemainingCredits] = useState(
    loadedOrgData?.remainingCredits || 0
  );

  React.useEffect(() => {
    if (loadedOrgData) {
      setOrgName(loadedOrgData.name || "");
      setTier(loadedOrgData.tier || "");
      setRemainingCredits(loadedOrgData.remainingCredits || 0);
    }
  }, [loadedOrgData]);

  const handleSave = async () => {
    try {
      const body = {
        name: orgName,
        tier,
        remainingCredits: Number(remainingCredits)
      };

      const response = await sendRequest(
        `/api/organizations/${loadedOrgData.orgId}`,
        "PUT",
        JSON.stringify(body),
        {
          "Content-Type": "application/json"
        }
      );

      if (response.status === 201) {
        if (onOrgUpdated) {
          onOrgUpdated();
        }
        onHide();
      }
    } catch (err) {
      console.error("Error updating org:", err);
    }
  };

  if (!loadedOrgData) {
    return null; // or a spinner if needed
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Organization Settings</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isLoading && <Spinner animation="border" />}
        {error && <p className="text-danger">{error}</p>}

        <Form>
          <Form.Group controlId="orgName" className="mb-3">
            <Form.Label>Organization Name</Form.Label>
            <Form.Control
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="tier" className="mb-3">
            <Form.Label>Tier</Form.Label>
            <Form.Control
              as="select"
              value={tier}
              onChange={(e) => setTier(e.target.value)}
            >
              <option value="">Select a tier</option>
              <option value="opal">Opal</option>
              <option value="silver">Silver</option>
              <option value="gold">Gold</option>
              <option value="platinum">Platinum</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="remainingCredits" className="mb-3">
            <Form.Label>Remaining Credits</Form.Label>
            <Form.Control
              type="number"
              value={remainingCredits}
              onChange={(e) => setRemainingCredits(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={isLoading}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
